// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

import IFormField from "./IFormField.js";

export default interface IFormComponentProps extends IFormField {}
